export default __webpack_public_path__ + "5037e0052076d0662132fed1b1083ca8.png";